import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { VbcHostService } from '../vbc/vbc.host.service';

interface ResetPasswordRequest {
  partnerId: string;
  email: string;
  nextUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class ResetPasswordService {
  constructor(
    private vbcHostService: VbcHostService,
    private http: HttpClient,
  ) {}

  public resetPassword(r: ResetPasswordRequest): Observable<boolean> {
    const params = new URLSearchParams();
    params.set('partnerId', r.partnerId);
    params.set('email', r.email);
    return this.http
      .post<Observable<boolean>>(
        this.vbcHostService.hostWithScheme() + '/ajax/v1/forgot-password/',
        params.toString(),
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          }),
          withCredentials: false,
        },
      )
      .pipe(
        take(1),
        map(() => true),
        catchError(() => {
          return of(false);
        }),
      );
  }
}
